<template>
    <div class="videolibrary container-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-transparent-background">
              <div class="card-header card-header-icon row">
                <div class="col-12 pl-0">
                  <h4 class="card-title card-title-irish-date">Video Library</h4>
                </div>
              </div>
            </div>
            <b-card no-body id="videoLibraryCard" class="p-3">
              <!-- <b-card-header class="pb-0">
                <div class="row">
                  <div class="col-12 mb-2 mb-md-0">
                    <div class="btn-group">
                      <button type="button" class="
                          btn
                          btn-bumblebee
                          btn-doomyoga
                          btn-tab
                          btn-doomyoga-secondary
                          active
                        ">
                        On Demand Videos
                      </button>
                    </div>
                  </div>
                </div>
              </b-card-header> -->
              <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
                <MediaLibraryCategoryList :client_name="client_name" 
                  :media_library="media_library"
                  :project_btn_class="'btn-mid'"
                  :search_input_class="'input-group-search-mid'"
                  :input_class="'form-control-mid'"
                  :btn_size_class="'btn-lg-mid'" 
                  :btn_variant_primary="'mid-primary'"
                  :btn_variant_info="'mid-info'"
                  :btn_variant_delete="'mid-danger'"
                  :category_tracks_url="'/my_irish_date/video_library/category/'"
                  :btn_group_actions_class="'btn-group-actions-mid'"
                  :dataset_not_found_data_class="'noDataFoundMID'"
                  :dataset_data_info_class="'datasetInfoMID'"
                  :dataset_pagination_class="'datasetPagerMID'"

                  
                :modal_class="'modal-irish-date'"
                :confirm_message_class="'message-modal-mid'"
                :btn_submit_class="'btn-mid btn-mid-submit'"
                :btn_danger_outline_class="'mid-danger-outline'"

                :form_label_class="'form-label-mid'"   
                :error_validation_msg_class="'error_validation_message_p_mid'"
                :video_preview_container_class="'video-preview-container-irish-date'"
                :add_video_btn_outline_variant="'mid-primary-outline'"
                :progress_bar_class="'progress-bar-irish-date'"
                :vselect_class="'form-group-vselect-mid'"

                :media_gallery_class="'media-gallery-mid'"
                :card_no_found_media_class="'card-no-found-media-mid'"
                :no_found_media_text_class="'no-media-text-mid'"
                :media_card_class="'media-card-mid'"

               
                :swal_confirm_button_class="'btn btn-bumblebee btn-mid  btn-mid-primary'"
            :swal_container_class="'swal-container-mid'"
                  />
  
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import $ from "jquery";
  
  import MediaLibraryCategoryList from '@/components/media_components/library/CategoryList.vue'
  
  export default {
    name: "MIDVideoLibrary",
    components: {
      MediaLibraryCategoryList
    },
    data() {
      return {
        client_name: "MID",
        media_library: "video_library",
      };
    },
    mounted() {
    },
    computed: {},
    created() {
    },
    methods: {
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/my_irish_date/video_library/CategoryList.vue